import React from 'react';

// components
import { Container } from '@/components/Grid/Container';

import { FeatureIcon, responsiveIconStyle } from '@/components/Feature';

// icons
import {
  IconTenderAcceptance,
  IconStockOptions,
  IconTailoredLoads,
} from '@loadsmart/icons';

// styles
import {
  SolutionsWrapper,
  Title,
  StyledFeatureGroup,
  StyledFeature,
  StyledFeatureTitle,
  Link,
  StyledFeatureDescription,
} from './SolutionsSection.styles';

export function SolutionsSection() {
  return (
    <SolutionsWrapper>
      <Container>
        <Title>FREE solutions to keep your trucks full & moving</Title>
        <StyledFeatureGroup>
          <StyledFeature>
            <FeatureIcon>
              <IconTenderAcceptance role="img" css={responsiveIconStyle} />
            </FeatureIcon>
            <StyledFeatureTitle as="h3">
              FREE
              <br /> CarrierGuide
            </StyledFeatureTitle>
            <StyledFeatureDescription>
              Simplify and streamline everyday tasks for your fleet so you can
              focus on profits.
            </StyledFeatureDescription>
            <Link
              href="https://loadsmart.com/carrier/tms/?utm_source=loadsmart&utm_medium=cta&utm_campaign=website-link-carrier-carriertms-q2-25"
              target="_blank"
            >
              Learn More
            </Link>
          </StyledFeature>
          <StyledFeature>
            <FeatureIcon>
              <IconStockOptions role="img" css={responsiveIconStyle} />
            </FeatureIcon>
            <StyledFeatureTitle as="h3">
              2.5% Truck Factoring
            </StyledFeatureTitle>
            <StyledFeatureDescription>
              Fast, simple, no hidden fees. Stop waiting 30+ days to get paid by
              your broker or shipper.
            </StyledFeatureDescription>
            <Link
              href="https://lp.loadsmart.com/factoring-sign-up"
              target="_blank"
            >
              Get Started
            </Link>
          </StyledFeature>
        </StyledFeatureGroup>
      </Container>
    </SolutionsWrapper>
  );
}
